import * as types from "../types/shipmentTypes";
import { initialShipmentState } from "../initialState";

export const shipment = (state = initialShipmentState, action) => {
  switch (action.type) {
    case types.SHIPMENT_CREATE:
      var newState = { ...state };
      newState.create = action.shipment;
      return newState;
    case types.SHIPMENT_READ:
      newState = { ...state };
      newState.read = action.shipments;
      return newState;
    default:
      return state;
  }
};

// export const
